<template>  
    <v-row>      
       <v-col>
          <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"            
            color="green"
            @click.stop="onClickStatus(-1)"
            >Aucun</v-chip>

           <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"            
            color="blue"
            @click.stop="onClickStatus(0)"
            >Renouvellement engagé</v-chip>

            <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"
            color="blue"
            @click.stop="onClickStatus(10)"
            >Choix collaborateur</v-chip>

            <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"
            color="blue"
            @click.stop="onClickStatus(20)"
            >Cotation</v-chip>

            <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"
            color="blue"
            @click.stop="onClickStatus(30)"
            >Commande</v-chip>

            <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"
            color="blue"
            @click.stop="onClickStatus(40)"
            >Livraison</v-chip>

            <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"
            color="blue"
            @click.stop="onClickStatus(50)"
            >StandBy</v-chip>
       </v-col>       
    </v-row>    
</template>

<script>

export default {
  name: 'ALeaseStatusChanger',  
  props: {        
    xSmall: {
      type: Boolean,
      value: true
    },
  },
  data: () => ({
   
  }),
  methods: {
    onClickStatus: function(status) {
      this.$emit("clickStatus", status)
    }
  }
}
</script>
